module.exports = __webpack_public_path__ + "static/the-painted-bird-f7dfdc243ee238f2994cea81e4505098.jpg";